export interface DemoStep {
  center: [number, number];
  zoom: number;
  pitch: number;
  bearing: number;
  duration: number; // fly animation ms
  dwell: number;    // ms to stay before next step
  highlights: string[];
  narrative: string;
  narrativeDuration: number; // ms — how long narrative stays visible
  alarm?: { driverId: number; code: string };
  toggleTraffic?: boolean; // hide traffic layer → reveal after fly animation
}

// Coordinates from reguladores-placeholder.ts intersections (PLACEHOLDER).
const R1_CENTER: [number, number] = [2.20307, 41.44961]; // Cruce 1 (centro)
const R2_CENTER: [number, number] = [2.21036, 41.44462]; // Cruce 2 (sur)
export const CITY_CENTER: [number, number] = [2.2094, 41.4505]; // Santa Coloma center

export function buildTrafficStep(
  center: [number, number],
  narrative: string,
): DemoStep {
  return {
    center,
    zoom: 17.5,
    pitch: 40,
    bearing: -15,
    duration: 3000,
    dwell: 18000,
    highlights: ['traffic-buttons'],
    narrative,
    narrativeDuration: 15000,
    toggleTraffic: true,
  };
}

export const DEMO_STEPS: DemoStep[] = [
  {
    // Step 1: Zoom out — overview
    center: CITY_CENTER,
    zoom: 15,
    pitch: 0,
    bearing: 0,
    duration: 2000,
    dwell: 16000,
    highlights: ['header-kpis'],
    narrative: 'Sistema de gestión inteligente ARS_93 — red semafórica de Santa Coloma de Gramenet monitorizada con indicadores de disponibilidad en tiempo real.',
    narrativeDuration: 13000,
  },
  {
    // Step 2: Fly to R1 — Cruce 1 (centro)
    center: R1_CENTER,
    zoom: 18.5,
    pitch: 50,
    bearing: -20,
    duration: 3000,
    dwell: 18000,
    highlights: ['cycle-panel'],
    narrative: 'Panel de ciclo con progreso *por fases* — aparece automáticamente al acercar la cámara a cualquier cruce.',
    narrativeDuration: 15000,
  },
  {
    // Step 3: Fly to R2 — Cruce 2 (sur)
    center: R2_CENTER,
    zoom: 18.5,
    pitch: 50,
    bearing: 10,
    duration: 3000,
    dwell: 18000,
    highlights: ['clock-badge'],
    narrative: 'Gestión automática de *planes horarios* — nocturno, base, punta y máxima demanda. Transiciones sin intervención.',
    narrativeDuration: 15000,
  },
  {
    // Step 4: Stay R2 + alarm
    center: R2_CENTER,
    zoom: 18.5,
    pitch: 50,
    bearing: 10,
    duration: 500,
    dwell: 15000,
    highlights: ['alarm-panel'],
    narrative: 'Cruce 2 — !Lámpara fundida! detectada. Clasificación por severidad, registro temporal y notificación al operador.',
    narrativeDuration: 12000,
    alarm: { driverId: 2, code: 'J' },
  },
  {
    // Step 5: Zoom out — overview of both regulators
    center: CITY_CENTER,
    zoom: 15,
    pitch: 0,
    bearing: 0,
    duration: 3000,
    dwell: 16000,
    highlights: ['overview-bar'],
    narrative: 'Los *reguladores gestionados* muestran fase y estado simultáneamente. Detección inmediata de cualquier anomalía.',
    narrativeDuration: 13000,
  },
  {
    // Step 6: Handoff narrative
    center: CITY_CENTER,
    zoom: 15,
    pitch: 0,
    bearing: 0,
    duration: 500,
    dwell: 10000,
    highlights: [],
    narrative: 'Sistema en *modo supervisión*. Las alarmas se notificarán automáticamente. Explore el mapa libremente.',
    narrativeDuration: 9000,
  },
];
